import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-left"><path d="M19.25 19.25V4.75L4.75 12L19.25 19.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowTriangleLeft;
